import { Text } from '@chakra-ui/react'

// LegiScan's terms of use require this attribution wherever their data is surfaced. Kept as
// its own tiny component (Task 9) so Task 11 can reuse it verbatim on other bill/roll-call
// surfaces instead of restating the exact wording per call site.
export function LegiScanCredit() {
  return (
    <Text fontSize="xs" color="muted">
      Legislative data via LegiScan · CC BY 4.0
    </Text>
  )
}
